import { API_ROOT, PAYPAL_API_KEY } from '../../constants';

export const CREATE_ORDER_URL = `${API_ROOT}/ebon/order`;

export const PAY_URL = `${API_ROOT}/payment-solution/paypal/pay`;
export const CAPTURE_URL = `${API_ROOT}/payment-solution/paypal/confirm`;

export const PAYPAL_OPTIONS = {
    clientId: PAYPAL_API_KEY,
    'enable-funding': 'venmo',
    'disable-funding': 'paylater,card',
    'data-sdk-integration-source': 'integrationbuilder_sc',
    currency: 'EUR'
};



// WEBPACK FOOTER //
// ./src/services/paypal/constants.js